import { getCurrentInstance } from "vue";

export const useSocket = (): { client: SocketIOClient.Socket } =>
	getCurrentInstance()?.appContext.config.globalProperties.$socket;
